import XCenters from 'gw-portals-metadata-js';

export default ['TranslateService', function (TranslateService) {
    function translate(key) {
        var obj = {};
        TranslateService.translate({
            object: obj,
            propName: 'value',
            displayKey: key
        });
        return function () {
            return obj.value;
        };
    }

    return XCenters.createSuiteMetadata(translate);
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-metadata-angular/InsuranceSuiteMetadataService.js
// module id = 317
// module chunks = 0